import React, { useState } from 'react';
import { unescape } from 'lodash/fp';
import RetryButton from 'components/Practice/shared/RetryButton';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import Textarea from 'components/shared/debouncedTextArea';
import gongLogo from 'images/gong-logo.svg';
import ElementBase from '../base.jsx';

const GongCallElement = ({ handleUpdate, applyChanges, content }) => {
  const [url, setUrl] = useState('');
  const [callIdInvalid, setCallIdInvalid] = useState(false);

  const onChange = value => {
    applyChanges(value);
    handleUpdate(value);
  };

  const inputChange = event => {
    setUrl(event.target.value);
  };

  const parseUrl = e => {
    const callUrl = new URL(e);
    const params = callUrl.searchParams;
    const highlights = JSON.parse(params.get('highlights'));

    const callId = params.get('call-id') || params.get('id');
    if (callId === null || callId === '') {
      setCallIdInvalid(true);
    }

    const startTimestamp = highlights ? highlights[0].from : params.get('from');
    const endTimestamp = highlights ? highlights[0].to : params.get('to');

    return {
      call_id: callId,
      start_timestamp: startTimestamp,
      end_timestamp: endTimestamp,
    };
  };

  const assembleUrl = call => {
    const baseUrl = 'https://app.gong.io/embedded-call';
    let callUrl = baseUrl + `?call-id=${call.call_id}`;
    if (call.start_timestamp && call.end_timestamp) {
      callUrl += `&from=${call.start_timestamp}&to=${call.end_timestamp}`;
    }
    return callUrl;
  };

  const onSubmit = e => {
    onChange(parseUrl(url));
  };

  const resetSetUrl = e => {
    setUrl('');
    setCallIdInvalid(false);
    return {
      call_id: null,
      start_timestamp: null,
      end_timestamp: null,
    };
  };

  return (
    <>
      {content.call_id && (
        <div className="EditorElement-content">
          <div className="EditorElement-body">
            <div className="EditorElement-fileHandler">
              <div className="d-f fd-c">
                <div className="Video-redo ta-r p-8">
                  <RetryButton onClick={e => onChange(resetSetUrl())} />
                </div>
                <iframe
                  title={t('lessons.editor.elements.gong_call')}
                  src={assembleUrl(content)}
                  frameBorder="0"
                  width="640"
                  height="815"
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {!content.call_id && !callIdInvalid && (
        <div className="EditorElement-fileHandler">
          <div className="EditorElement-uploadArea">
            <img
              className="EditorElement-icon"
              src={gongLogo}
              alt={t('lessons.editor.elements.gong_call')}
            />
            <form onSubmit={onSubmit}>
              <input
                className="EditorElement-uploadButton NewInput NewInput--light"
                type="url"
                value={url}
                onInput={inputChange}
                placeholder={t('lessons.editor.gong_call.url_placeholder')}
                required
                pattern=".*\.gong.io/.*"
                title="Example: https://app.gong.io/call?id=12345"
              />
              <div className="d-f f-sh-0">
                <button className="NewButton NewButton--white" type="submit">
                  {t('common.submit')}
                </button>
              </div>
            </form>
            <p>
              {t('lessons.editor.gong_call.account_required') + ' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://intercom.help/lessonly/en/articles/5883928-gong-lessonly-integration"
              >
                {t('lessons.editor.gong_call.learn_more')}
              </a>
            </p>
          </div>
        </div>
      )}
      {!content.call_id && callIdInvalid && (
        <div className="EditorElement-content">
          <div className="EditorElement-body">
            <div className="EditorElement-fileHandler">
              <div className="d-f fd-c">
                <div className="Video-redo">
                  <div>
                    <p className="p-10">
                      {t('lessons.editor.gong_call.try_again_feedback')}
                    </p>
                    <p className="p-10">
                      {t('lessons.editor.gong_call.try_again_check')}
                    </p>
                    <p className="p-10">
                      {t('lessons.editor.gong_call.try_again_example')}
                    </p>
                  </div>
                  <RetryButton onClick={e => onChange(resetSetUrl())} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="EditorElement-footer EditorElement-footer--caption">
        <Text
          variant={TEXT_VARIANTS.BODY}
          placeholder={t('element_builder.caption_placeholder')}
          component={Textarea}
          onChange={e => onChange({ caption: e })}
          value={unescape(content.caption)}
        />
      </div>
    </>
  );
};

export default ElementBase(GongCallElement);
